/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IncidentLogAwareProcessDto } from '../../models/incident-log-aware-process-dto';

export interface IncidentLogGetById$Params {

/**
 * Incident log ID
 */
  id: number;
}

export function incidentLogGetById(http: HttpClient, rootUrl: string, params: IncidentLogGetById$Params, context?: HttpContext): Observable<StrictHttpResponse<IncidentLogAwareProcessDto>> {
  const rb = new RequestBuilder(rootUrl, incidentLogGetById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IncidentLogAwareProcessDto>;
    })
  );
}

incidentLogGetById.PATH = '/incident-log/{id}';